import {I18n} from 'aws-amplify/utils';
import {SimplePageHeader} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '../../../hooks/useVerifiedPermissions';
import {config} from '../config';
import {ComponentsReloadButton} from '../buttons/ReloadButton';
import {FilterRecordsButton} from '../buttons/FilterRecordsButton';
import {AddRecordButton} from '../buttons/AddRecordButton';
import {DeleteRecordButton} from '../buttons/DeleteRecordButton';
import {GenerateContactButton} from '../../test-data/buttons/GenerateContactButton';
import {ContactStatus} from '../types';

interface IndexPageHeaderProps {
    onFilterChange: (status: ContactStatus | null) => void;
}

const useTools = (onFilterChange: (status: ContactStatus | null) => void) => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [
        <FilterRecordsButton key='filter' onFilterChange={onFilterChange} defaultStatus={ContactStatus.ACTIVE}/>,
        <ComponentsReloadButton key='reload'/>,
        <GenerateContactButton key='generate'/>
    ];

    if (allowedActions.includes('DeleteContact')) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes('CreateContact')) {
        tools.push(<AddRecordButton key='add'/>);
    }


    return tools;
};

export const IndexPageHeader = ({onFilterChange}: IndexPageHeaderProps) => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools(onFilterChange)}
        />
    );
};
